/** Permit expiration reminder triggers (must match backend permitExpiringEmailTriggers.cjs). */

export const PERMIT_EXPIRING_EMAIL_TRIGGER_DEFINITIONS = [
  {
    id: "permit_expiring_7d",
    label: "Permit expiring in 7 days (Permitting / Construction)",
    group: "Permits",
    assignmentRecipients: true,
  },
];
